import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';
import useReactRouter from 'use-react-router';
import { useSession } from '../SessionProvider';

const defaultLimit = '100';
const limitKey = (pathname: string, user: { id: string }) =>
  `${pathname.replace(/\//g, '')}#${user.id}__disp_emp_limit`;

export const getSavedDisplayEmployeeLimit = (pathname: string, user: { id: string }): string => {
  if (window.localStorage) {
    const limit = window.localStorage.getItem(limitKey(pathname, user));
    if (!isEmpty(limit)) {
      return limit as string;
    }
  }
  const limit = Cookies.get(limitKey(pathname, user));
  return isEmpty(limit) ? defaultLimit : (limit as string);
};

export const saveDisplayEmployeeLimit = (pathname: string, user: { id: string }, limit: string) => {
  if (window.localStorage) {
    window.localStorage.setItem(limitKey(pathname, user), limit);
  } else {
    Cookies.set(limitKey(pathname, user), limit);
  }
};

export const useDisplayEmployeeLimit = (): [string, (value: string) => void] => {
  const {
    location: { pathname }
  } = useReactRouter();
  const { user } = useSession();
  const limit = getSavedDisplayEmployeeLimit(pathname, user);
  return [limit, limit => saveDisplayEmployeeLimit(pathname, user, limit)];
};
